<div mat-dialog-title class="bg-gray py-4 d-flex justify-content-start" *ngIf="isModal">
    <h4 class="w-100 m-0">User List</h4>
    <i class="flaticon-close cursor-pointer fs-18 text-black" mat-dialog-close></i>

</div>

<div class="col-lg-12 mb-10" *ngIf="!isModal">
    <h6 class="w-100 m-0 px-4">Allow Access Users List</h6>
</div>
<mat-dialog-content class="py-4 p-0">
    <div class="d-flex justify-content-end px-4">
        <mat-form-field appearance="outline" style="width: 300px;">
            <mat-label>Search User</mat-label>
            <input matInput type="text" [formControl]="searchValue">
            <button *ngIf="searchValue?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch();">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
    </div>
    <div class="access-user-table px-4 table-responsive">
        <table class="table">
            <thead>
                <th>Name</th>
                <th>Role</th>
                <th *ngIf="isModal">Action</th>
            </thead>
            <tbody>
                <ng-container *ngIf="accessAcountList.length > 0">
                    <tr *ngFor="let account of accessAcountList">
                        <td>
                            {{account?.userName}}
                        </td>
                        <td>
                            {{account?.roles?.name}}
                        </td>
                        <td *ngIf="isModal">
                            <button mat-menu-item class="profile-switch-button modal-switch-btn p-0 fs-14"
                                (click)="switchUser(account)">
                                <span class="material-symbols-outlined fs-20">sync</span>
                                Switch Account
                            </button>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
    <div class="d-flex justify-content-center align-items-center" *ngIf="isLoading">
        <mat-spinner class="small-spinner"></mat-spinner>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="border-t-1" *ngIf="isModal">
    <button mat-raised-button mat-dialog-close color="warn">Close</button>
</mat-dialog-actions>